/**
 * JSON utility module for symbol
 */
define("tmds/utils/__baseSymbolUtils", [
	"tmds/symbols/FieldSymbol",
	"tmds/symbols/SimpleFillSymbol",
	"tmds/symbols/SimpleLineSymbol",
	"tmds/symbols/SimplePointSymbol",
	"tmds/symbols/TextSymbol",
	"tmds/validator"
], function(FieldSymbol, SimpleFillSymbol, SimpleLineSymbol, SimplePointSymbol, TextSymbol, validator) {
	"use strict";
	
	/**
	 * create symbol object from a JSON representation
	 * @param symJson {tmds.symbols.Symbol} a symbol in JSON representation
	 * @return {tmds.symbols.Symbol}
	 */
	function fromJson(symJson) {
		var symbol = null;
		
		if (! validator.isDataObject(symJson) || ! validator.isString(symJson.type)) {
			
			throw new Error('Invalid Symbol Object - ' + symJson + ' passed');
		}

		if (symJson) {
			switch (symJson.type) {
				case "FieldSymbol":
					symbol = new FieldSymbol(symJson);
					break;
				case "SimplePointSymbol":
					symbol = new SimplePointSymbol(symJson);
					break;
				case "SimpleLineSymbol":
					symbol = new SimpleLineSymbol(symJson);
					break;
				case "SimpleFillSymbol":
					symbol = new SimpleFillSymbol(symJson);
					break;
				case "TextSymbol":
					symbol = new TextSymbol(symJson);
					break;
				default:
					break;
			}
		}
		
		if(symbol == null)
			throw new Error('Invalid Symbol Object - ' + symJson + ' passed');
		
		return symbol;
	}
	
	/**
	 * create default symbol based on the spatial type
	 * @param type {String} Point | Line | Polyline
	 * @return {tmds.symbols.Symbol}
	 */
	function fromSpatialType(type) {
		var symbol = null;
		
		if (! validator.isString(type)) {
			
			throw new Error('Invalid type value - ' + type + ' passed');
		}

		if (type) {
			switch (type) {
				case "Extent":
					symbol = new SimpleFillSymbol();
					break;
				case "Point":
					symbol = new SimplePointSymbol();
					break;
				case "Line":
				case "Polyline":
					symbol = new SimpleLineSymbol();
					break;
				default:
					break;
			}
		}
		
		if(symbol == null)
			throw new Error('Invalid type value - ' + type + ' passed');
		
		return symbol;
	}
	
	var utils = {
		'fromJson' : fromJson,
		'fromSpatialType' : fromSpatialType
	};
	
	return utils;
});